// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-JP2":"JP2_dpu-detail-JP2__t08c0"};